// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1488":"c8fb6b9e","3648":"48484966","9533":"c8fb6b9e"}[chunkId] + ".chunk.css";
};